// extracted by mini-css-extract-plugin
export default {"component":"DepartureSelect_component__1sssy","calendar":"DepartureSelect_calendar__UEvn4","calendarInfo":"DepartureSelect_calendarInfo__dJFR-"};